import { circlePath, ellipsePath, starPath, heartPath, groundPath } from "./artHelpers";

export const LOCKED_PAGES = [
  {
    id: "pumpkin-hero",
    title: "Pumpkin Hero",
    category: "heroes",
    difficulty: 3,
    blurb: "Flexing jack-o-lantern muscles to save the night",
    art: [
      { d: starPath(60, 60, 9) },
      { d: starPath(340, 150, 8) },
      { d: starPath(140, 90, 6) },
      { d: circlePath(330, 80, 40) },
      { d: circlePath(320, 70, 7), line: true },
      { d: "M 20 448 L 20 330 L 60 330 L 60 448 Z" },
      { d: "M 28 348 L 40 348 L 40 362 L 28 362 Z M 40 380 L 52 380 L 52 396 L 40 396 Z", line: true },
      { d: "M 340 448 L 340 350 L 375 350 L 375 448 Z" },
      { d: "M 348 368 L 358 368 L 358 382 L 348 382 Z M 358 396 L 368 396 L 368 412 L 358 412 Z", line: true },
      {
        d: "M 162 238 C 100 276 66 352 58 432 C 90 414 102 432 98 450 C 136 432 158 442 156 458 L 244 458 C 242 442 264 432 302 450 C 298 432 310 414 342 432 C 334 352 300 276 238 238 Z",
      },
      { d: "M 166 244 L 234 244 L 238 336 L 162 336 Z" },
      { d: starPath(200, 290, 24) },
      { d: circlePath(200, 182, 50) },
      { d: "M 194 128 C 190 114 192 102 198 92 C 208 96 212 108 210 122 C 206 130 198 132 194 128 Z" },
      { d: "M 168 172 L 192 172 L 180 194 Z" },
      { d: "M 208 172 L 232 172 L 220 194 Z" },
      { d: "M 172 206 L 228 206 C 226 222 210 232 200 232 C 190 232 174 222 172 206 Z" },
      { d: "M 170 254 C 122 250 98 218 104 186 C 106 174 120 172 124 184 C 130 208 148 226 176 232 Z" },
      { d: circlePath(112, 182, 16) },
      { d: "M 230 254 C 278 250 302 218 296 186 C 294 174 280 172 276 184 C 270 208 252 226 224 232 Z" },
      { d: circlePath(288, 182, 16) },
      { d: "M 162 336 L 238 336 L 236 352 L 164 352 Z" },
      { d: "M 172 352 L 172 414 L 196 414 L 196 352 Z" },
      { d: "M 204 352 L 204 414 L 228 414 L 228 352 Z" },
      { d: "M 160 412 L 202 412 L 204 448 L 156 448 Z" },
      { d: "M 198 412 L 240 412 L 244 448 L 196 448 Z" },
    ],
  },
  {
    id: "bat-vigilante",
    title: "Bat Vigilante",
    category: "heroes",
    difficulty: 3,
    blurb: "Scalloped cape, midnight attitude",
    art: [
      { d: circlePath(320, 90, 44) },
      { d: circlePath(308, 80, 8), line: true },
      { d: starPath(60, 70, 8) },
      { d: starPath(150, 50, 7) },
      {
        d: "M 60 120 L 84 120 L 66 158 L 92 156 L 44 216 L 60 172 L 38 174 Z",
      },
      {
        d: "M 160 244 C 108 268 84 330 82 416 C 104 404 114 416 110 430 C 136 418 150 426 148 440 L 252 440 C 250 426 264 418 290 430 C 286 416 296 404 318 416 C 316 330 292 268 240 244 Z",
      },
      { d: "M 168 250 L 232 250 L 236 330 L 164 330 Z" },
      {
        d: "M 200 272 C 190 262 176 262 170 270 C 178 272 180 278 174 284 C 186 280 192 286 190 294 C 196 288 204 288 210 294 C 208 286 214 280 226 284 C 220 278 222 272 230 270 C 224 262 210 262 200 272 Z",
      },
      { d: circlePath(200, 180, 44) },
      {
        d: "M 154 176 C 156 152 174 142 200 142 C 226 142 244 152 246 176 C 247 190 238 196 230 190 C 222 184 214 186 210 194 C 205 203 195 203 190 194 C 186 186 178 184 170 190 C 162 196 153 190 154 176 Z",
      },
      { d: ellipsePath(182, 172, 10, 8) },
      { d: ellipsePath(218, 172, 10, 8) },
      { d: "M 188 212 C 194 218 206 218 212 212", line: true },
      { d: "M 168 256 C 136 268 124 292 134 312 C 138 320 150 318 150 308 C 146 296 156 282 174 278 Z" },
      { d: "M 232 256 C 264 268 276 292 266 312 C 262 320 250 318 250 308 C 254 296 244 282 226 278 Z" },
      { d: "M 164 330 L 236 330 L 234 348 L 166 348 Z" },
      { d: "M 172 348 L 172 412 L 196 412 L 196 348 Z" },
      { d: "M 204 348 L 204 412 L 228 412 L 228 348 Z" },
      { d: "M 160 410 L 202 410 L 204 446 L 156 446 Z" },
      { d: "M 198 410 L 240 410 L 244 446 L 196 446 Z" },
      { d: groundPath(452) },
    ],
  },
  {
    id: "kitty-witch",
    title: "Kitty Witch",
    category: "kitty",
    difficulty: 2,
    blurb: "Purrfectly magical with a hat to match",
    art: [
      { d: circlePath(64, 80, 32) },
      { d: circlePath(56, 72, 6), line: true },
      { d: starPath(340, 70, 9) },
      { d: starPath(300, 150, 7) },
      { d: heartPath(60, 320, 18) },
      { d: heartPath(345, 250, 14) },
      {
        d: "M 40 130 C 40 112 62 108 68 120 C 74 108 92 110 92 124 C 92 134 82 138 70 138 L 52 138 C 44 138 40 136 40 130 Z",
      },
      { d: groundPath(452) },
      { d: "M 168 122 L 200 44 L 236 122 Z" },
      { d: ellipsePath(200, 126, 74, 15) },
      { d: "M 192 92 L 210 92 L 208 106 L 190 106 Z" },
      { d: "M 158 190 L 150 136 L 198 174 Z" },
      { d: "M 242 190 L 250 136 L 202 174 Z" },
      { d: "M 164 180 L 160 154 L 188 174 Z" },
      { d: "M 236 180 L 240 154 L 212 174 Z" },
      { d: "M 246 128 L 268 116 L 266 142 Z" },
      { d: "M 246 128 L 228 114 L 228 140 Z" },
      { d: circlePath(246, 128, 7) },
      { d: circlePath(200, 222, 56) },
      { d: ellipsePath(181, 222, 13, 18) },
      { d: ellipsePath(219, 222, 13, 18) },
      { d: circlePath(177, 214, 4), line: true },
      { d: circlePath(215, 214, 4), line: true },
      { d: "M 195 246 L 205 246 L 200 254 Z" },
      { d: "M 200 254 C 196 262 188 262 184 256 M 200 254 C 204 262 212 262 216 256", line: true },
      { d: "M 148 238 L 118 232 M 148 250 L 120 254 M 252 238 L 282 232 M 252 250 L 280 254", line: true },
      { d: circlePath(152, 244, 8) },
      { d: circlePath(248, 244, 8) },
      {
        d: "M 162 268 C 140 312 136 372 142 398 C 146 416 166 422 200 422 C 234 422 254 416 258 398 C 264 372 260 312 238 268 C 226 250 174 250 162 268 Z",
      },
      { d: ellipsePath(172, 416, 18, 11) },
      { d: ellipsePath(228, 416, 18, 11) },
      { d: "M 268 422 L 276 424 L 340 254 L 332 250 Z" },
      {
        d: "M 322 246 C 344 232 366 230 382 240 C 372 252 372 264 378 276 C 360 274 344 282 336 296 C 326 282 318 266 322 246 Z",
      },
      { d: "M 330 250 C 348 242 362 242 372 248", line: true },
    ],
  },
  {
    id: "kitty-ghost",
    title: "Kitty Ghost",
    category: "kitty",
    difficulty: 2,
    blurb: "Boo! Just a kitty in a bedsheet",
    art: [
      { d: circlePath(64, 84, 34) },
      { d: circlePath(56, 76, 6), line: true },
      { d: starPath(150, 60, 8) },
      { d: starPath(350, 70, 9) },
      { d: heartPath(330, 140, 14) },
      { d: groundPath(462) },
      {
        d: "M 140 195 C 140 150 148 124 160 108 C 156 94 164 82 174 84 C 182 86 184 94 182 102 C 194 97 206 97 218 102 C 216 94 218 86 226 84 C 236 82 244 96 240 108 C 252 124 260 150 260 195 L 260 358 C 260 386 246 396 234 388 C 224 382 216 388 216 400 C 216 414 204 422 196 412 C 190 404 180 402 172 410 C 160 422 142 416 140 396 Z",
      },
      { d: ellipsePath(178, 210, 14, 19) },
      { d: ellipsePath(222, 210, 14, 19) },
      { d: ellipsePath(200, 252, 10, 13) },
      { d: "M 150 226 L 132 222 M 150 238 L 134 242 M 250 226 L 268 222 M 250 238 L 266 242", line: true },
      { d: circlePath(286, 300, 16) },
      { d: "M 280 296 L 282 302 M 286 295 L 288 301 M 292 296 L 293 302", line: true },
      { d: "M 92 412 L 144 412 L 144 422 L 92 422 Z" },
      { d: "M 96 422 L 140 422 L 136 458 L 100 458 Z" },
      { d: circlePath(112, 392, 8) },
      { d: starPath(152, 402, 8) },
      { d: heartPath(84, 380, 9) },
      { d: "M 158 130 C 158 122 166 120 168 126", line: true },
    ],
  },
  {
    id: "chibi-reaper",
    title: "Chibi Reaper",
    category: "anime",
    difficulty: 3,
    blurb: "A tiny ghost hunter with a big heart",
    art: [
      { d: starPath(50, 60, 9) },
      { d: starPath(140, 50, 6) },
      { d: starPath(60, 150, 7) },
      { d: "M 60 210 L 100 206 M 52 232 L 88 232 M 62 254 L 94 258", line: true },
      { d: "M 60 300 C 60 258 76 246 96 246 C 116 246 132 258 132 300 L 132 348 C 128 360 120 356 116 348 C 112 342 106 344 104 352 C 102 362 92 362 90 354 C 88 346 82 344 76 350 C 68 358 60 354 60 340 Z" },
      { d: circlePath(84, 288, 5), line: true },
      { d: circlePath(108, 288, 5), line: true },
      {
        d: "M 136 210 C 128 118 172 92 200 92 C 228 92 272 118 264 210 C 264 232 250 240 239 232 C 230 226 221 228 217 238 C 210 251 190 251 183 238 C 179 228 170 226 161 232 C 150 240 136 232 136 210 Z",
      },
      { d: "M 178 96 C 172 76 186 62 196 70 C 204 76 200 88 192 94 Z" },
      {
        d: "M 160 196 C 160 146 176 124 200 124 C 224 124 240 146 240 196 C 240 230 222 252 200 252 C 178 252 160 230 160 196 Z",
      },
      { d: ellipsePath(180, 192, 13, 17) },
      { d: ellipsePath(220, 192, 13, 17) },
      { d: "M 172 180 L 182 174 M 212 180 L 222 174", line: true },
      { d: "M 190 226 C 195 233 205 233 210 226", line: true },
      { d: circlePath(164, 216, 7) },
      { d: circlePath(236, 216, 7) },
      { d: "M 168 300 L 232 300 C 252 348 258 420 260 448 L 140 448 C 142 420 148 348 168 300 Z" },
      { d: "M 168 304 C 148 310 134 326 130 344 C 128 354 140 360 146 352 C 154 340 164 330 176 326 Z" },
      { d: "M 232 304 C 252 310 266 326 270 344 C 272 354 260 360 254 352 C 246 340 236 330 224 326 Z" },
      { d: circlePath(136, 352, 11) },
      { d: circlePath(264, 352, 11) },
      { d: "M 166 352 L 234 352 L 232 368 L 168 368 Z" },
      { d: circlePath(200, 360, 7) },
      { d: "M 282 120 L 294 124 L 268 442 L 254 440 Z" },
      { d: "M 294 130 C 344 118 374 140 378 174 C 344 152 312 150 290 160 C 286 148 288 138 294 130 Z" },
      { d: groundPath(458) },
    ],
  },
  {
    id: "fox-spirit",
    title: "Fox Spirit",
    category: "anime",
    difficulty: 3,
    blurb: "Flame tails and ninja vibes",
    art: [
      { d: circlePath(340, 80, 36) },
      { d: circlePath(330, 72, 6), line: true },
      { d: starPath(50, 80, 8) },
      { d: starPath(120, 60, 6) },
      { d: starPath(370, 180, 7) },
      { d: groundPath(455) },
      { d: "M 70 262 L 110 262 L 108 272 L 72 272 Z" },
      { d: "M 74 322 L 106 322 L 104 332 L 76 332 Z" },
      { d: "M 74 272 L 106 272 L 104 322 L 76 322 Z" },
      { d: "M 90 310 C 80 298 84 286 90 278 C 96 286 100 298 90 310 Z" },
      { d: "M 90 250 L 90 262", line: true },
      { d: "M 158 192 L 142 118 L 196 172 Z" },
      { d: "M 242 192 L 258 118 L 204 172 Z" },
      { d: "M 162 178 L 152 136 L 190 168 Z" },
      { d: "M 238 178 L 248 136 L 210 168 Z" },
      { d: circlePath(200, 220, 54) },
      { d: "M 150 196 C 168 186 232 186 250 196 L 248 212 C 230 202 170 202 152 212 Z" },
      { d: "M 150 200 L 118 188 L 126 210 Z" },
      { d: "M 150 206 L 120 216 L 130 228 Z" },
      { d: circlePath(200, 202, 8), line: true },
      { d: ellipsePath(180, 232, 11, 14) },
      { d: ellipsePath(220, 232, 11, 14) },
      { d: "M 176 224 L 184 220 M 216 224 L 224 220", line: true },
      { d: ellipsePath(200, 262, 22, 15) },
      { d: "M 194 256 L 206 256 L 200 266 Z" },
      { d: "M 168 250 L 148 244 M 168 258 L 150 262 M 232 250 L 252 244 M 232 258 L 250 262", line: true },
      {
        d: "M 164 268 C 140 306 134 356 140 384 C 144 402 164 408 200 408 C 236 408 256 402 260 384 C 266 356 260 306 236 268 C 224 252 176 252 164 268 Z",
      },
      { d: ellipsePath(200, 362, 30, 34) },
      { d: ellipsePath(170, 402, 17, 10) },
      { d: ellipsePath(230, 402, 17, 10) },
      {
        d: "M 250 330 C 296 312 324 320 340 292 C 348 314 336 330 346 346 C 318 344 298 356 288 374 C 280 354 264 342 250 330 Z",
      },
      { d: "M 256 356 C 292 352 310 362 318 384 C 300 380 286 388 280 402 C 268 386 258 372 256 356 Z" },
    ],
  },
  {
    id: "vampire-queen",
    title: "Vampire Queen",
    category: "glam",
    difficulty: 3,
    blurb: "Fierce, fabulous and fang-tastic",
    art: [
      { d: circlePath(70, 80, 36) },
      { d: circlePath(62, 72, 6), line: true },
      { d: starPath(150, 60, 7) },
      { d: heartPath(340, 200, 13) },
      { d: heartPath(52, 300, 11) },
      {
        d: "M 300 60 C 308 52 318 52 322 60 C 326 52 336 52 344 60 C 336 58 330 62 328 68 C 324 62 318 62 316 68 C 314 62 308 58 300 60 Z",
      },
      { d: circlePath(146, 118, 17) },
      { d: circlePath(254, 118, 17) },
      {
        d: "M 154 190 C 142 116 172 92 200 92 C 228 92 258 116 246 190 C 238 148 232 138 200 136 C 168 138 162 148 154 190 Z",
      },
      { d: "M 178 104 L 186 82 L 200 98 L 214 82 L 222 104 Z" },
      { d: circlePath(200, 94, 4), line: true },
      { d: circlePath(200, 188, 48) },
      { d: ellipsePath(182, 190, 11, 15) },
      { d: ellipsePath(218, 190, 11, 15) },
      { d: "M 170 178 L 178 174 M 230 178 L 222 174", line: true },
      { d: "M 188 218 C 194 224 206 224 212 218", line: true },
      { d: "M 190 221 L 194 234 L 198 221 Z" },
      { d: "M 202 221 L 206 234 L 210 221 Z" },
      { d: circlePath(160, 208, 7) },
      { d: circlePath(240, 208, 7) },
      {
        d: "M 140 224 L 146 216 L 150 224 L 156 216 L 158 228 C 152 226 146 230 144 236 C 142 230 138 228 134 232 Z",
      },
      {
        d: "M 244 224 L 250 216 L 254 224 L 260 216 L 266 228 C 260 226 254 230 252 236 C 250 230 246 228 242 232 Z",
      },
      { d: "M 188 236 L 212 236 L 210 258 L 190 258 Z" },
      { d: "M 168 258 L 232 258 C 276 306 296 398 306 452 L 94 452 C 104 398 124 306 168 258 Z" },
      { d: "M 132 386 C 164 404 236 404 268 386 C 274 420 284 442 292 452 L 108 452 C 116 442 126 420 132 386 Z" },
      { d: "M 168 262 C 148 276 140 296 146 314 C 149 322 160 320 160 310 C 158 298 164 284 176 278 Z" },
      { d: "M 232 262 C 252 276 260 296 254 314 C 251 322 240 320 240 310 C 242 298 236 284 224 278 Z" },
      { d: circlePath(200, 320, 22) },
      { d: "M 188 302 C 192 292 208 292 212 302", line: true },
      { d: "M 192 318 L 198 318 L 195 324 Z M 202 318 L 208 318 L 205 324 Z", line: true },
      { d: groundPath(460) },
    ],
  },
  {
    id: "stitched-sweetheart",
    title: "Stitched Sweetheart",
    category: "glam",
    difficulty: 3,
    blurb: "Handmade with love... and a little stitching",
    art: [
      { d: starPath(60, 70, 8) },
      { d: starPath(340, 80, 8) },
      { d: heartPath(340, 120, 15) },
      { d: heartPath(60, 200, 12) },
      {
        d: "M 141 165 C 138 106 262 106 259 165 C 252 132 236 120 200 120 C 164 120 148 132 141 165 Z",
      },
      { d: circlePath(138, 196, 11) },
      { d: circlePath(132, 224, 10) },
      { d: circlePath(128, 252, 9) },
      { d: circlePath(262, 196, 11) },
      { d: circlePath(268, 224, 10) },
      { d: circlePath(272, 252, 9) },
      { d: "M 124 188 L 108 178 L 110 198 Z" },
      { d: "M 124 188 L 112 204 L 130 202 Z" },
      { d: circlePath(124, 190, 5) },
      { d: "M 276 188 L 292 178 L 290 198 Z" },
      { d: "M 276 188 L 288 204 L 270 202 Z" },
      { d: circlePath(276, 190, 5) },
      { d: "M 152 150 C 152 126 248 126 248 150 L 248 226 C 248 250 152 250 152 226 Z" },
      { d: "M 152 150 C 180 140 220 140 248 150", line: true },
      { d: circlePath(180, 192, 12) },
      { d: circlePath(222, 194, 9) },
      { d: "M 214 208 L 230 208 M 218 214 L 226 214", line: true },
      { d: "M 160 158 L 176 156 M 164 152 L 164 162 M 172 151 L 172 161", line: true },
      { d: "M 186 228 L 214 228 M 190 224 L 190 232 M 200 224 L 200 232 M 210 224 L 210 232", line: true },
      { d: circlePath(166, 214, 6) },
      { d: circlePath(236, 214, 6) },
      { d: "M 190 250 L 210 250 L 210 262 L 190 262 Z" },
      { d: "M 176 254 L 186 254 L 186 270 L 176 270 Z" },
      { d: "M 214 254 L 224 254 L 224 270 L 214 270 Z" },
      { d: "M 172 268 L 228 268 C 264 320 278 410 282 452 L 118 452 C 122 410 136 320 172 268 Z" },
      { d: "M 150 360 L 178 356 L 182 384 L 154 388 Z" },
      { d: "M 130 430 L 268 430", line: true },
      { d: "M 178 452 L 178 470 L 196 470 L 196 452 Z" },
      { d: "M 204 452 L 204 470 L 222 470 L 222 452 Z" },
      { d: "M 168 470 L 200 470 L 202 496 L 164 496 Z" },
      { d: "M 200 470 L 232 470 L 236 496 L 198 496 Z" },
      { d: groundPath(486) },
    ],
  },
];
